import { render, staticRenderFns } from "./ViewBillDetailsModal.vue?vue&type=template&id=1d570322&scoped=true&"
import script from "./ViewBillDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ViewBillDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewBillDetailsModal.vue?vue&type=style&index=0&id=1d570322&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d570322",
  null
  
)

export default component.exports